export default __webpack_public_path__ + "static/media/Sume_MauricioRamirez.4478e949.png";